import React from 'react';
import { Card, Button } from 'react-bootstrap';
import "./Scheme.css";

function SchemeCard({id, scheme, category, title, date, onClickDetails, onClickApply}) {
    return (
    
                            <Card className="h-100 shadow-sm" style={{ 'borderRadius': '40px', 'border': '1.14px solid #E4E4E7' }}>
                                <Card.Img variant="top" src={scheme} />

                                <Card.Body>
                                    <span
                                        className="badge mb-2 text-white "
                                        style={{
                                            backgroundColor: category === 'Ongoing'
                                                ? '#12C144'
                                                : category === 'Upcoming'
                                                    ? '#F0B330'
                                                    : '#E55858',
                                            fontSize: "0.75rem",
                                            padding: "0.5em 0.9em",
                                            borderRadius: "11366.55px"
                                        }}
                                    >
                                        {category}
                                    </span>

                                    <Card.Title className="mb-3">Application For {title}</Card.Title>

                                    <div className="mb-3 fw-semibold">
                                        {category === 'Ongoing' && (
                                            <div>Deadline: <strong>{date}</strong></div>
                                        )}
                                        {category === 'Upcoming' && (
                                            <div>Start Date: <strong>{date}</strong></div>
                                        )}
                                        {category === 'Closed' && (
                                            <div>Closed on: <strong>{date}</strong></div>
                                        )}
                                    </div>

                                    <div className="d-flex gap-2">
                                        <Button className="details-button" style={{'width':'40%'}} onClick={onClickDetails}>Details</Button>
                                        {category === 'Ongoing' && (
                                            <Button className="text-white apply-btn" style={{'width':'40%','marginLeft':'auto'}} onClick={onClickApply}>Apply Now</Button>
                                        )}
                                    </div>

                                </Card.Body>
                            </Card>
    )
}

export default SchemeCard;